import { render, staticRenderFns } from "./DetailVersionList.vue?vue&type=template&id=ab7154d8&scoped=true&"
import script from "./DetailVersionList.vue?vue&type=script&lang=js&"
export * from "./DetailVersionList.vue?vue&type=script&lang=js&"
import style0 from "./DetailVersionList.vue?vue&type=style&index=0&id=ab7154d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7154d8",
  null
  
)

export default component.exports